export const EVENTS = {
  CERTIFICATION_REGISTRATION: {
    OPEN: 'CERTIFICATION_REGISTRATION.open',
    REGISTER: 'CERTIFICATION_REGISTRATION.REGISTER'
  }
};
